<template>
  <div class="searchbox">
    <div class="top">
      <div class=" special">
        <span class="search-btn" @click="searchFn">
          search
          <span class="reset" @click="reset" v-if="showreset"></span>
        </span>
        <div class="inp-search">
        <input type="text"  placeholder="Please input" class="inp-search-in" v-model="keyWord" @input="search" />
        </div>
      </div>
    </div>
    <div class="middle" md="6">
      <div class="left" @click="isshow = !isshow">
        <div
          :class="['text-uppercase newCss',{'category-active':categoryFlag }]"
          @click="chooseCategory"
        >
        <span style=" width:80%">{{selectVal}}</span>
          
          <!-- <i style="color:#333333;font-weight: 1000;"></i> -->
          <img class="el-icon-arrow-up xl_icon" src="../../../assets/imgs/search/icon_xl.png" alt="">
        </div>
      </div>
      <div class="v-line">|</div>
      <div class="right">
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="—"
          start-placeholder="start"
          end-placeholder="end"
          clear-icon="false"
          format="MM/dd"
          :unlink-panels="true"
          align="center"
          @change="changeData"
        ></el-date-picker>
      </div>
      <div class="category">
        <transition name="el-zoom-in-top">
          <div v-show="isshow" class="transition-box category-list">
            <!-- <div
              :class="['list-item',{'active':currentIndex == item}]"
              v-for="(item, index) in categorylist"
              :key="index"
              @click="selected(item)"
            >{{item}}</div> -->
            <ul class="tab-nav">
              <li>
                <div class="nav_one" @click="selected('All')">
                  <span class="title">All</span>
                </div>
              </li>
              <li v-for="(item,index) in navList" :key="index">
                <div class="par_nav" @click="openNav(index,item.children.length)">
                  <span class="title">{{item.name}}</span>
                  <i v-if="item.children.length" id="right-btn" class="el-icon-arrow-down"></i>
                </div>
                <ul class="nav_cd_box">
                  <li class="nav-n" v-for="(n,i) in item.children" :key="i" @click="selected(n.name)">
                    <!-- <span style="font-size:30px">·</span> -->
                    <span class="nav-n-title">{{n.name}}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
    <div class="bottom text-center">
      A total of
      <span class="text-num">{{totalNum}}</span> messages were found
    </div>
  </div>
</template>

<script>
import { getNavList } from "@/network/home.js";
export default {
  name: "SearchBox",
  props: ["totalNum"],
  data() {
    return {
      navList: [
        {
          title: "Video",
          name: "/video",
          children: [],
        },
        {
          title: "News",
          name: "news",
          children: [
            {
              title: "Breaking",
              name: "/news",
            },
            {
              title: "Politics",
              name: "/news",
            },
            {
              title: "Metro",
              name: "/news",
            },
            {
              title: "China",
              name: "/news",
            },
            {
              title: "World",
              name: "/news",
            },
          ],
        },
        {
          title: "Biz",
          name: "News",
          children: [
            {
              title: "Company",
              name: "/news",
            },
            {
              title: "Money Talks",
              name: "BusinessIntroduction",
            },
            {
              title: "Global",
              name: "BusinessIntroduction",
            },
          ],
        },
        {
          title: "Culture",
          name: "AboutUs",
          children: [
            {
              title: "Art",
              name: "BusinessIntroduction",
            },
            {
              title: "Backtage Peek",
              name: "BusinessIntroduction",
            },
            {
              title: "Education",
              name: "BusinessIntroduction",
            },
            {
              title: "Entertainment",
              name: "BusinessIntroduction",
            },
            {
              title: "Fashion",
              name: "BusinessIntroduction",
            },
            {
              title: "Food",
              name: "BusinessIntroduction",
            },
            {
              title: "24 SolarTerms",
              name: "BusinessIntroduction",
            },
          ],
        },
        {
          title: "Opinion",
          name: "AboutUs",
          children: [],
        },
        {
          title: "Feature",
          name: "/feature",
          children: [],
        },
        {
          title: "More Topic",
          name: "AboutUs",
          children: [
            {
              title: "More",
              name: "BusinessIntroduction",
            },
            {
              title: "Topic",
              name: "BusinessIntroduction",
            },
            {
              title: "Culture",
              name: "BusinessIntroduction",
            },
          ],
        },
      ],
      keyWord: "",
      pickerOptions: {},
      value1: "",
      categoryFlag: false, //分类高亮的flag
      isshow: false, // carteory下拉框的 flag
      categorylist: [], // 分类列表
      currentIndex: 0, //点击分类item的索引,
      fullDate: {},
      showreset: false,
      selectVal: "All",
    };
  },
  mounted() {
    this.searchFn();
    this.getListFn();
  },
  methods: {
    //获取菜单
    getListFn() {
      getNavList().then(res => {
        this.navList = res.data;
      });
    },
    openNav(index, num) {
      let _this = this;
      let nav = document.querySelectorAll(".par_nav"); //获取父级菜单栏，以便添加选中样式
      let items = document.querySelectorAll(".nav_cd_box"); //获取容纳子级菜单栏的容器，以便动态设置高度，实现下拉效果

      //-----------------可注释部分开始------注释后则不是手风琴效果------------------
      // 遍历菜单栏，移除所有选中后的样式   添加此段可实现手风琴效果，注释则实现多展示效果
      for (let i = 0; i < nav.length; i++) {
        // nav[index].classList.contains("nav-n-box-active") 判断标签内是否含有该class属性，以布尔值类型返回
        if (
          items[i].style.height == "" ||
          items[i].style.height == "0rem" ||
          nav[index].classList.contains("nav-n-box-active")
        ) {
          let height = items[index].style.height;
          items[index].style.height = height;
        } else {
          items[i].style.height = "0px";
        }
        nav[i].classList.remove("nav-n-box-active");
      }
      //-----------------可注释部分结束------------------------

      //根据子菜单栏的高度判断，是否展开菜单栏，若有进行遍历操作，那么每次点击某个菜单栏的时候 height 都为 0
      if (
        items[index].style.height == "" ||
        items[index].style.height == "0px"
      ) {
        //num 为子菜单栏的个数，根据子菜单栏确定容器的高度
        items[index].style.height = num * 28 + "px";
        //添加右箭头旋转样式
        nav[index].classList.add("nav-n-box-active");
      } else {
        items[index].style.height = "0px";
        //移除右箭头旋转样式
        nav[index].classList.remove("nav-n-box-active");
      }
      //------------------------------------------
    },
    searchFn() {
      let tempData = {
        title: this.keyWord,
        start: this.fullDate.startdate,
        end: this.fullDate.enddate,
        page: 1,
        size: 9,
      };
      if (this.selectVal !== "All") {
        tempData.classification = this.selectVal;
      }
      this.$emit("searchData", tempData);
    },
    search() {
      if (this.keyWord.length != 0) {
        this.showreset = true;
      } else {
        this.showreset = false;
      }
    },
    changeData() {
      var date1 = new Date(this.value1[0]);
      var date2 = new Date(this.value1[1]);
      var y1 = date1.getFullYear();
      var m1 = date1.getMonth() + 1;
      var d1 = date1.getDate();

      if (m1 < 10) {
        m1 = "0" + m1;
      }
      if (d1 < 10) {
        d1 = "0" + d1;
      }
      var y2 = date2.getFullYear();
      var m2 = date2.getMonth() + 1;
      var d2 = date2.getDate();

      if (m2 < 10) {
        m2 = "0" + m2;
      }
      if (d2 < 10) {
        d2 = "0" + d2;
      }
      var startdate = y1 + "" + m1 + "" + d1;
      var enddate = y2 + "" + m2 + "" + d2;
      this.fullDate.startdate = startdate;
      this.fullDate.enddate = enddate;
    },
    // 重置按钮
    reset() {
      this.keyWord = "";
    },
    // 选择分类高亮
    selected(item) {
      // this.currentIndex = item.name;
      this.selectVal = item;
      this.isshow = false;
    },
    chooseCategory() {
      this.categoryFlag = !this.categoryFlag;
      let arrow = document.querySelectorAll(".el-icon-arrow-up");

      if (!arrow[0].classList.contains("r_active")) {
        arrow[0].classList.add("r_active");
      } else {
        arrow[0].classList.remove("r_active");
      }
    },
  },
};
</script>
<style lang="less">
.left .r_active {
  transform: rotate(180deg) !important;
}
@media screen and (max-width: 768px) {
  .searchbox {
    .newCss {
      text-align: center;
    }
    .el-range-input {
      width: 30% !important;
    }
    .el-date-editor .el-range__icon {
      margin-left: 0.06rem;
      color: #666666;
      position: absolute;
      right: 0.75rem !important;
      top: 2px;
    }
  }
  .el-date-range-picker {
    width: 100%;
    .el-picker-panel__body {
      width: 100%;
      min-width: 100%;
    }
  }
  .el-picker-panel {
    left: 0 !important;
  }
  .el-date-range-picker__content.is-left {
    border-left: 1px solid #e4e4e4;
  }
  .el-date-range-picker__content.is-right {
    visibility: hidden;
    display: none;
  }
  .el-picker-panel__content {
    position: relative;
    /* margin: 15px; */
    // left: 31px;
    width: 100%;
  }
}
.searchbox {
  .active {
    font-weight: bolder;
  }
  .el-date-editor .el-range-separator {
    // line-height: 20px;
  }
  .category-active {
    color: #5bacaf;
  }
  .el-date-editor {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .el-input__inner {
    border: none;
  }
  .el-range-input {
    width: 100%;
  }
  .el-date-editor .el-range__icon {
    margin-left: 0.06rem;
    color: #666666;
    position: absolute;
    right: 14px;
    font-size: 18px;
  }
  .middle {
    position: relative;
    .v-line {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #ccc;
    }
    .xl_icon {
      width: 12px;
    }
  }
}
// 定义在768-1200间的图标或者文字重叠问题
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .searchbox .top .inp-search {
    width: 76% !important;
  }
  .searchbox .el-input__inner {
    height: 0.5rem !important;
  }
  .el-date-editor .el-range__icon {
    line-height: 0.5rem !important;
  }
  .searchbox .middle .left {
    height: 0.5rem !important;
    width: 30%;
    float: left;
    position: relative;
    border: 1px solid #ccc;
    line-height: 0.5rem !important;
    margin-top: 0.25rem !important;
  }
  .el-input__inner {
    border: 1px solid #ccc;
    border-radius: 0;
    width: 2.5rem !important;
  }
  .el-range-input {
    width: 85% !important;
  }
  .el-date-editor .el-range__icon {
    margin-left: 0.06rem;
    color: #666666;
    position: absolute;
    right: -3px !important;
  }
}

@media screen and (min-width: 768px) {
  .searchbox {
    .newCss {
      text-align: left;
      padding-left: 10px;
    }
    .el-range-input {
      width: 35%;
    }
    .searchbox .el-date-editor {
      width: 60%;
      height: 100%;
      text-align: center;
    }
    .el-input__inner {
      border: 1px solid #ccc;
      border-radius: 0;
      width: 1.8rem;
      padding: 5px 10px;
      height: 32px;
    }

    .el-date-editor .el-range-separator {
      line-height: 0.3rem;
    }
  }
  .xl_icon {
    float: right;
    margin: 12px;
  }
}
</style>


<style lang="less" scoped>
@media screen and (min-width: 768px) {
  html {
    font-size: 50px !important;
  }
  .searchbox {
    width: 100%;
    float: left;
    background: #ffffff;
    .text-num {
      color: #5bacaf;
    }
    .nav_one {
      text-align: left !important;
    }
    .top {
      width: 50%;
      float: left;
      .special {
        width: 100%;
        padding-top: 0.2rem !important;
        margin-left: 0.33rem;
        margin-top: 0.1rem;
      }
      .inp-search {
        font-size: 0.2rem;
        height: 0.4rem;
        width: 60%;
        float: right;
        background: #f4f4f4;
        font-family: FranklinGothic-Demi;
        padding-left: 10px;
        .inp-search-in {
          width: 85%;
          background: #f4f4f4;
          height:100%;
        }
      }
      .search-btn {
        cursor: pointer;
        position: relative;
        background: #5bacaf;
        color: #ffffff;
        font-size: 0.2rem;
        display: block;
        float: right;
        line-height: 0.4rem;
        font-family: FranklinGothic-Demi;
        padding: 0 0.15rem;
        margin-right: 50px;
      }
      .reset {
        height: 0.2rem;
        width: 0.2rem;
        background: url("~@/assets/imgs/search/close_icon.png");
        background-size: 100% 100%;
        position: absolute;
        right: 1rem;
        top: 0.1rem;
      }
    }
    .middle {
      height: 0.9rem;
      width: 50%;
      font-size: 0.2rem;
      line-height: 0.9rem;
      float: left;
      .v-line {
        display: none;
      }
      .left {
        height: 0.4rem;
        width: 30%;
        float: left;
        position: relative;
        border: 1px solid #ccc;
        line-height: 0.4rem;
        margin-top: 0.3rem;
      }
      .right {
        width: 49%;
        float: left;
        padding-left: 10px;
        height: 0.43rem;
        padding-top: 3px;
      }
      .category {
        position: absolute;
        top: 0.7rem;
        width: 30%;
        z-index: 99;
        .category-list {
          background: #ffffff;
          width: 100%;
          .list-item {
            color: #666666;
            line-height: 0.4rem;
            border-left: 1px solid #ccc;
            border-right: 1px solid #ccc;
            border-bottom: 1px solid #ebebeb;
            padding-left: 0.3rem;
            cursor: pointer;
          }
        }
      }
    }
    .bottom {
      height: 1.1rem;
      font-size: 0.42rem;
      line-height: 1.1rem;
      display: none;
      color: #999999;
    }
  }
}

@media screen and (max-width: 768px) {
  html {
    font-size: 40px !important;
  }
  .searchbox {
    width: 100%;
    background: #ffffff;
    .text-num {
      color: #5bacaf;
    }
    .top {
      height: 1.6rem;
      width: 100%;
      // pppp
      .special {
        width: 100%;
        height: 0.9rem;
        float: left;
        margin-top: 0.3rem;
      }
      .inp-search {
        font-size: 0.45rem;
        -webkit-appearance: none; /*清除ios默认圆角*/
        border-radius: 0;
        height: 0.9rem;
        width: calc(100% - 3rem);
        float: right;
        background: #f4f4f4;
        font-family: FranklinGothic-Demi;
        padding-left: 10px;
        .inp-search-in {
           width: 85%;
          background: #f4f4f4;
          height:100%;
        }
      }
      .search-btn {
        position: relative;
        background: #5bacaf;
        color: #ffffff;
        font-size: 0.4rem;
        display: block;
        float: right;
        line-height: 0.9rem;
        font-family: FranklinGothic-Demi;
        margin-right: 0.5rem;
        width: 2rem;
        text-align: center;
      }
      .reset {
        height: 0.4rem;
        width: 0.4rem;
        background: url("~@/assets/imgs/search/close_icon.png");
        background-size: 100% 100%;
        position: absolute;
        right: 2.2rem;
        top: 0.25rem;
      }
    }
    .middle {
      height: 0.9rem;
      width: 100%;
      font-size: 0.4rem;
      line-height: 0.9rem;
      .left {
        height: 0.9rem;
        width: 50%;
        float: left;
        position: relative;
      }
      .right {
        height: 0.9rem;
        width: 49%;
        float: left;
        padding-left: 10px;
      }
      .category {
        position: absolute;
        border-top: 1px solid #cccccc;
        top: 1rem;
        width: 100%;
        z-index: 99;
        .category-list {
          background: #ffffff;
          width: 100%;
          .list-item {
            color: #666666;
            border-bottom: 1px solid #ebebeb;
            padding-left: 0.5rem;
            line-height: 1.2rem;
          }
        }
      }
    }
    .bottom {
      height: 1rem;
      font-size: 0.42rem;
      line-height: 1rem;
      color: #999999;
    }
    .tab-nav {
      border-left: none;
      border-right: none;
      padding: 0 20px;
    }
  }
}
.tab-nav {
  border-left: 1px solid #ebebeb;
  border-right: 1px solid #ebebeb;
  // margin: 10px 10px;
  li {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;
    user-select: none;
    .par_nav,
    .nav_one {
      padding: 10px 6px 10px 0px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      .title {
        color: #666666;
        line-height: 0.4rem;
        // border-left: 1px solid #ccc;
        // border-right: 1px solid #ccc;
        // border-bottom: 1px solid #ebebeb;
        padding-left: 0.2rem;
        cursor: pointer;
      }
      i {
        transition: 0.3s;
        font-size: 16px;
        color: #666666;
      }
      span {
        display: inline-block;
        text-align: left;
        color: #666666;
        // font-size: 40px;
        // margin-left: 5px;
      }
    }
    .nav_cd_box {
      transition: 0.3s;
      width: 100%;
      height: 0;
      overflow: hidden;
      border-bottom: 1px solid #ebebeb;
      .nav-n {
        // width: 45% !important;
        font-size: 40px;
        color: #666;
        height: 28px;
        text-align: left;
        line-height: 30px;
        transition: 0.3s;
        font-family: Open Sans;
        padding-left: 0.3rem;
        font-size: 13px;
        // float: left;
        .nav-n-title {
          padding-left: 0.13rem;
        }
        &:hover {
          color: #3daeaf;
        }
      }
    }
  }
}
//点击后右箭头的反转效果
.nav-n-box-active {
  #right-btn {
    transform: rotate(180deg) !important;
  }
}
</style>